import * as z from "zod/v4";

export const ConfirmProductVisualizationSchema = z.object({
  productId: z.string(),
  productImageUrl: z.url(),
});

export type ConfirmProductVisualization = z.infer<
  typeof ConfirmProductVisualizationSchema
>;
